import http from '../http'

const API_URL = "afp"

class EPS_API {

  async getAllAFP() {
    const response = await http(`${API_URL}/select`, 'GET')
    return response || null
  }


}

export default new EPS_API()